import { audienceAllowed } from './privacyConsent';
/**
 * Mesure d'audience, respectueuse de la vie privee et AGNOSTIQUE.
 *
 * Aucun outil n'est code en dur : l'integration s'active uniquement si les
 * variables d'environnement ci-dessous sont definies au build. Tant qu'elles
 * sont absentes, ce module ne fait rien (aucun script charge, aucun impact).
 *
 * Variables (a placer dans frontend/.env) :
 *   REACT_APP_ANALYTICS_SRC     URL du script (ex. https://plausible.io/js/script.js)
 *   REACT_APP_ANALYTICS_DOMAIN  domaine suivi, pour Plausible (ex. g1sport.fr)
 *   REACT_APP_ANALYTICS_ID      identifiant de site, pour Umami/Matomo
 *
 * Compatible avec les solutions sans cookie (Plausible, Umami, Matomo en mode
 * anonyme), activées ici uniquement après accord pour la mesure d’audience.
 */

const SRC = process.env.REACT_APP_ANALYTICS_SRC;
const DOMAIN = process.env.REACT_APP_ANALYTICS_DOMAIN;
const SITE_ID = process.env.REACT_APP_ANALYTICS_ID;

let charge = false;

export function initAnalytics(): void {
  if (document.querySelector('script[data-audience-src]') || !audienceAllowed() || charge || !SRC || typeof document === 'undefined') return;
  charge = true;

  const s = document.createElement('script');
  s.defer = true;
  s.src = SRC;
  if (DOMAIN) s.setAttribute('data-domain', DOMAIN);
  if (SITE_ID) s.setAttribute('data-website-id', SITE_ID); // convention Umami
  document.head.appendChild(s);
}

/**
 * Signale un changement de page dans une application monopage (SPA).
 * Sans cet appel, les outils ne comptent que le premier chargement, car la
 * navigation react-router ne recharge pas la page.
 */
export function trackPageview(url: string): void {
  if (document.querySelector('script[data-audience-src]') || !audienceAllowed() || !SRC || typeof window === 'undefined') return;
  const w = window as any;
  // Plausible
  if (typeof w.plausible === 'function') {
    w.plausible('pageview', { u: url });
    return;
  }
  // Umami
  if (w.umami && typeof w.umami.track === 'function') {
    w.umami.track();
  }
}
